module.exports = __webpack_public_path__ + "static/media/homeitem10.64f74a2f.png";